{
  "raporharitapersonel": {
    "Baslik": "Personeelskaartrapport",
    "Arama": "Zoeken",
    "Filtrele": "Filteren",
    "Yenile": "Vernieuwen",
    "Kullanici": "Gebruiker",
    "Tarih": "Datum",
    "Uygula": "Toepassen",
    "Temizle": "Wissen",
    "Marker": "Marker",
    "Polyline": "Route",
    "HaritaKatmanlari": "Kaartlagen",
    "SokakHaritasi": "Straatkaart",
    "UyduGoruntusu": "Satellietbeeld",
    "TopografikHarita": "Topografische Kaart",
    "Cap": "Nauwkeurigheid",
    "Kapat": "Sluiten"
  }
}
